import { useTranslation } from "react-i18next"
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../../components/Card"

export function IntroPage({ goToNextPage }: { goToNextPage: () => void }) {
    const { t } = useTranslation(["vennootschapofniet", "common"])

    return (
        <div>
            <h1>{t("intro__title")}</h1>
            <h2>{t("intro__slug")}</h2>
            <p>{t("intro__description")}</p>

            <div className="mt-8 grid gap-4 md:grid-cols-2 ">
                <Card>
                    <CardHeader>
                        <CardTitle>{t("intro__emz_title")}</CardTitle>
                        <CardDescription>
                            {t("intro__emz_description")}
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        <ul className="list-disc list-inside">
                            <li>{t("intro__emz_bullet_1")}</li>
                            <li>{t("intro__emz_bullet_2")}</li>
                            <li>{t("intro__emz_bullet_3")}</li>
                        </ul>
                    </CardContent>
                    <CardFooter></CardFooter>
                </Card>
                <Card>
                    <CardHeader>
                        <CardTitle>{t("intro__vennootschap_title")}</CardTitle>
                        <CardDescription>
                            {t("intro__vennootschap_description")}
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        <ul className="list-disc list-inside	">
                            <li>{t("intro__vennootschap_bullet_1")}</li>
                            <li>{t("intro__vennootschap_bullet_2")}</li>
                            <li>{t("intro__vennootschap_bullet_3")}</li>
                        </ul>
                    </CardContent>
                    <CardFooter></CardFooter>
                </Card>
            </div>

            <p>{t("intro__start")}</p>
            
            <button onClick={goToNextPage} className="button-primary">{t("button__intro", { ns: "common" })}</button>
        </div>
    )
}